<div *ngIf="isAutoPayLoading && !isPayU">
    <app-please-wait-nach></app-please-wait-nach>
</div>
<div *ngIf="isAutoPayLoading && isPayU">
    <div class="row justify-content-center align-items-center mt-3 d-flex flex-lg-row-reverse">
        <div class="col-lg-6 col-12">
            <div class="row justify-content-center mt-4">
                <div class="col-8 blue_box p-4 text-center">
                    <h3 class="heading">Setup Auto-Pay</h3>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-11 white_box p-4">
                    <div class="row justify-content-center">
                        <div class="col-11">
                            <p class="text-center mb-4" style="font-size: 1rem;">Enter Your UPI ID for Setting up the
                                Auto-Pay Mandate.</p>
                            <form [formGroup]="PayUForm" (ngSubmit)="onSubmitPayU()" novalidate>

                                <div class="row mt-2 justify-content-center">
                                    <div class="col-9 col-md-7 mt-1">
                                        <div class="form-group">
                                            <label for="autoPayIds " class="control-label">UPI Id</label>
                                            <input type="text" class="form-control" id="autoPayIds"
                                                formControlName="autoPayIds" required="" />
                                            <div class="error"
                                                *ngIf="PayUForm.get('autoPayIds')?.invalid && (PayUForm.get('autoPayIds').dirty || PayUForm.get('autoPayIds').touched)">
                                                <div *ngIf="PayUForm.get('autoPayIds').errors?.required">Please Enter
                                                    UPI ID.</div>
                                            </div>
                                            <div class="success" *ngIf="vpaError !== ''">
                                                <div> {{vpaError}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3 col-md-3 mt-1">
                                        <div class="form-group" style="text-align: center;margin-top: 0.5rem;">
                                            <button type="button" class="btn btn-warning mt-3"
                                                style="padding: .5rem; padding-block: 0.1rem;"
                                                (click)="verifyVPA()">Verify</button>
                                        </div>
                                    </div>
                                    <div class="col-11 m-4" style="text-align: center;margin-top: 0.5rem;">
                                        <button class="btn btn-warning mt-3"
                                            [disabled]="!PayUForm.valid || !enableSubmitPayU"
                                            type="submit">Proceed</button>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <p
                                            style="font-family: 'Roboto', sans-serif; color: #244564; font-size: 0.95rem; line-height: 150%; margin-bottom: 10px;font-weight: 400;">
                                            <small>
                                                Your loan is approved! To activate your loan, click on Proceed to set up
                                                Auto-Pay and pay the upfront EMI and processing fee using your UPI
                                                account.
                                            </small>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-5 col-11">
            <app-assist-left></app-assist-left>
        </div>
    </div>
</div>
<div *ngIf="!isAutoPayLoading">
    <div class="row justify-content-center align-items-center mt-3 d-flex flex-lg-row-reverse">
        <div class="col-lg-6 col-12">
            <div class="row justify-content-center mt-4">
                <div class="col-8 blue_box p-4 text-center">
                    <h3 class="heading">🔒 Secure Your Loan with Auto-Debit (eNACH)</h3>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-11 white_box p-4">
                    <div class="row justify-content-center">
                        <div class="col-11">
                            <p class="text-center mb-4" style="font-size: 1rem;">This allows us to automatically deduct
                                your EMIs from your bank account — <b>secure, convenient, and stress-free!</b></p>
                            <form [formGroup]="nachForm" (ngSubmit)="onSubmit()" novalidate>

                                <div class="row mt-2 justify-content-center">
                                    <div class="col-sm-5 col-12 mt-1">
                                        <div class="form-group">
                                            <label for="Traveltype " class="control-label">Account Type</label>
                                            <select class="form-select" id="accountType" formControlName="accountType"
                                                required="">
                                                <option disabled="" selected="" value="">Choose Account Type</option>
                                                <option value="Savings">Savings</option>
                                                <option value="Current">Current</option>
                                            </select>
                                            <div class="error"
                                                *ngIf="m.accountType.invalid && (m.accountType.dirty || m.accountType.touched)">
                                                <div *ngIf="m.accountType.errors?.required">Please select Account Type.
                                                </div>
                                            </div>
                                            <!-- <fieldset class="border" style="margin-top: 3px;border-radius: 3px;padding-left: .3rem;">
                                            <legend class="w-auto" style="font-size: 14px; font-weight: 100; border-bottom: none; margin-bottom: -6px; padding: 0 5px 0 5px;">Account Type <span class="required-asterisk" style="color:  red;">*</span></legend>
                                            <select class="form-control no-outline" id="accountType" formControlName="accountType" required="">
                                            <option disabled="" selected="" value="">Choose Account Type</option>
                                            <option value="Savings">Savings</option>
                                            <option value="Current">Current</option>
                                            </select>
                                        </fieldset>
                                        <div class="error" *ngIf="m.accountType.invalid && (m.accountType.dirty || m.accountType.touched)">
                                            <div *ngIf="m.accountType.errors?.required">Please select Account Type.</div>
                                        </div> -->
                                        </div>
                                    </div>
                                    <div class="col-sm-5 col-12 mt-1">
                                        <div class="form-group">
                                            <label for="Mobilenumber" class="control-label">IFSC Code</label>
                                            <input placeholder="IFSC Code" #ifscCode type="text"
                                                formControlName="bankId" class="form-control"
                                                (focusout)="getBankName($event);" style="text-transform: uppercase;">
                                            <div *ngIf="m.bankId.touched && m.bankId.invalid" class="error">
                                                <div *ngIf="m.bankId.errors?.required">IFSC Code is required</div>
                                                <div *ngIf="m.bankId.errors?.pattern">IFSC Code is invalid</div>
                                            </div>
                                        </div>
                                        <!-- <div class="form-group">
                                        <fieldset class="border" style="margin-top: 3px;border-radius: 3px;padding-left: .3rem;">
                                            <legend class="w-auto" style="font-size: 14px;font-weight: 100;border-bottom: none;margin-bottom: -6px;padding: 0 5px 0 5px;">Enter IFSC Code <span class="required-asterisk" style="color:  red;">*</span></legend>
                                            <input placeholder="IFSC Code" #ifscCode type="text" formControlName="bankId" class="form-control no-outline" (focusout)="getBankName($event); upperCase($event)">
                                        </fieldset>
                                        <div *ngIf="m.bankId.touched && m.bankId.invalid" class="error">
                                            <div *ngIf="m.bankId.errors?.required">IFSC Code is required</div>
                                            <div *ngIf="m.bankId.errors?.pattern">IFSC Code is invalid</div>
                                        </div>
                                    </div> -->
                                    </div>
                                </div>


                                <div class="row justify-content-center">
                                    <div class="col-sm-10 col-12">
                                        <div class="form-group">
                                            <label for="Mobilenumber" class="control-label">Account Number</label>
                                            <input type="text" placeholder="Enter Account Number"
                                                formControlName="accountNumber"
                                                [readonly]="eNachData.accountNumber.length > 0 ? true : false"
                                                class="form-control" maxlength="18" minlength="1">
                                            <div *ngIf="m.accountNumber.touched && m.accountNumber.invalid"
                                                class="error">
                                                <div *ngIf="m.accountNumber.errors?.required">Account number is required
                                                </div>
                                                <div *ngIf="m.accountNumber.errors?.pattern">Invalid account number
                                                </div>
                                                <div *ngIf="m.accountNumber.errors?.accountNumberMismatch">{{
                                                    m.accountNumber.errors?.accountNumberMismatch }}</div>
                                            </div>
                                        </div>
                                        <!-- <div class="form-group">
                                        <fieldset class="border" style="margin-top: 3px;border-radius: 3px;padding-left: 0.5rem;">
                                            <legend class="w-auto" style="font-size: 14px;font-weight: 100;border-bottom: none;margin-bottom: -6px;padding: 0 5px 0 5px;">Enter Account Number <span class="required-asterisk" style="color: red;">*</span></legend>
                                            <input type="text" placeholder="Account Number" formControlName="accountNumber" class="form-control no-outline" maxlength="18" minlength="1">
                                        </fieldset>
                                        <div *ngIf="m.accountNumber.touched && m.accountNumber.invalid" class="error">
                                            <div *ngIf="m.accountNumber.errors?.required">Account number is required</div>
                                            <div *ngIf="m.accountNumber.errors?.pattern">Invalid account number</div>
                                        </div>
                                   </div> -->
                                    </div>
                                </div>


                                <!-- <div class="row mt-4 justify-content-center">
                                <div class="col-sm-5 col-12">
                                    <div class="form-group">
                                        <label>IFSC Code</label>
                                        <input placeholder="IFSC Code" #ifscCode type="text" formControlName="bankId" class="form-control mb-2" (focusout)="getBankName($event); upperCase($event)">
                                        <div *ngIf="m.bankId.touched && m.bankId.invalid" class="error">
                                            <div *ngIf="m.bankId.errors?.required">IFSC Code is required</div>
                                            <div *ngIf="m.bankId.errors?.pattern">IFSC Code is invalid</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-12">
                                    <div class="form-group">
                                        <label>Account Number</label>
                                        <input type="text" placeholder="Account Number" formControlName="accountNumber" class="form-control mb-2" maxlength="18" minlength="1">
                                        <div *ngIf="m.accountNumber.touched && m.accountNumber.invalid" class="error">
                                            <div *ngIf="m.accountNumber.errors?.required">Account
                                                number is required</div>
                                            <div *ngIf="m.accountNumber.errors?.pattern">Invalid account
                                                number</div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                                <div class="row justify-content-center mb-4" *ngIf="bankName!=''">
                                    <div class="col-10 bank_name">
                                        {{bankName}}
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-12 consent-box">
                                        <div class="boxes">
                                            <input type="checkbox" style="margin-right: 1rem;" id="box1"
                                                (change)="checkValue($event)" [(ngModel)]="conditionAccept"
                                                formControlName="chkAgree">
                                            <label for="box1"> I agree to terms & conditions of the agreement</label>
                                        </div>
                                        <!-- <p class="mb-1 text-left consent-p">I authorize Mihuru to cancel the flight
                                            on my behalf in the
                                            event I fail to pay the EMIs on time.</p> -->
                                    </div>
                                </div>
                                <div class="row justify-content-center text-center buttonDiv">
                                    <div class="col-6">
                                        <button class="btn btn-warning mt-3" style="width: max-content;"
                                            [disabled]="!nachForm.valid" type="submit">Set Up Auto-Debit Now​</button>
                                    </div>
                                </div>
                                <div style="padding-inline: 2rem;">
                                    <p
                                        style="text-align: left; font-family: 'Roboto', sans-serif; color: #244564; font-size: 0.95rem; line-height: 150%; margin-bottom: 10px;font-weight: 400;">
                                        <small>
                                            ✅ No manual payments - Avoid missed EMIs & penalties
                                        </small>
                                    </p>
                                    <p
                                        style="text-align: left; font-family: 'Roboto', sans-serif; color: #244564; font-size: 0.95rem; line-height: 150%; margin-bottom: 10px;font-weight: 400;">
                                        <small>
                                            ✅ 100% secure & RBI-compliant
                                        </small>
                                    </p>
                                    <p
                                        style="text-align: left; font-family: 'Roboto', sans-serif; color: #244564; font-size: 0.95rem; line-height: 150%; margin-bottom: 10px;font-weight: 400;">
                                        <small>✅ Takes less than a minute​</small>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-5 col-11">
            <app-assist-left></app-assist-left>
        </div>
    </div>
    <app-nach-pop [timerSub]="paymentStatusSubscription"></app-nach-pop>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>